import React from "react";

const images = [
    {href : "./Kinderkunst/1.jpeg", caption: ""},
    {href : "./Kinderkunst/2.jpeg", caption: ""},
    {href : "./Kinderkunst/3.jpeg", caption: ""},
    {href : "./Kinderkunst/4.jpeg", caption: ""},
    {href : "./Kinderkunst/5.jpeg", caption: ""},
    {href : "./Kinderkunst/6.jpeg", caption: ""},
    {href : "./Kinderkunst/7.jpeg", caption: ""},
    {href : "./Kinderkunst/8.jpeg", caption: ""},
    {href : "./Kinderkunst/9.jpeg", caption: ""},
    {href : "./Kinderkunst/10.jpeg", caption: ""},
    {href : "./Kinderkunst/11.jpeg", caption: ""},
    {href : "./Kinderkunst/12.jpeg", caption: ""},
    {href : "./Kinderkunst/13.jpeg", caption: ""},
    {href : "./Kinderkunst/14.jpeg", caption: ""},
    {href : "./Kinderkunst/15.jpeg", caption: ""},
    {href : "./Kinderkunst/16.jpeg", caption: ""},
    {href : "./Kinderkunst/17.jpeg", caption: ""},
    {href : "./Kinderkunst/18.jpeg", caption: ""},
    {href : "./Kinderkunst/19.jpeg", caption: ""},
    {href : "./Kinderkunst/20.jpeg", caption: ""},
    {href : "./Kinderkunst/21.jpeg", caption: ""},
    {href : "./Kinderkunst/22.jpeg", caption: ""},
    {href : "./Kinderkunst/23.jpeg", caption: ""},
    {href : "./Kinderkunst/24.jpeg", caption: ""},
    {href : "./Kinderkunst/25.jpeg", caption: ""},
    {href : "./Kinderkunst/27.jpeg", caption: ""},
    {href : "./Kinderkunst/28.jpeg", caption: ""},
    {href : "./Kinderkunst/29.jpeg", caption: ""},
    {href : "./Kinderkunst/30.jpeg", caption: ""},
    {href : "./Kinderkunst/31.jpeg", caption: ""},
    {href : "./Kinderkunst/32.jpg", caption: ""},
    {href : "./Kinderkunst/33.jpg", caption: ""},
    {href : "./Kinderkunst/34.jpg", caption: ""},
    {href : "./Kinderkunst/35.jpg", caption: ""},
    {href : "./Kinderkunst/36.jpg", caption: ""},
    {href : "./Kinderkunst/37.jpg", caption: ""},
    {href : "./Kinderkunst/38.jpg", caption: ""},
    {href : "./Kinderkunst/39.jpg", caption: ""},
    {href : "./Kinderkunst/40.jpg", caption: ""},
    {href : "./Kinderkunst/41.jpg", caption: ""},
    {href : "./Kinderkunst/42.jpg", caption: ""},
    {href : "./Kinderkunst/43.jpg", caption: ""},
    {href : "./Kinderkunst/44.jpg", caption: ""},
    {href : "./Kinderkunst/45.jpg", caption: ""},
    {href : "./Kinderkunst/46.jpg", caption: ""},
    {href : "./Kinderkunst/47.jpg", caption: ""},
    {href : "./Kinderkunst/48.jpg", caption: ""},
    {href : "./Kinderkunst/49.jpg", caption: ""},
    {href : "./Kinderkunst/50.jpg", caption: ""},
    {href : "./Kinderkunst/51.jpg", caption: ""},
    {href : "./Kinderkunst/52.jpg", caption: ""},
    {href : "./Kinderkunst/53.jpg", caption: ""},
    {href : "./Kinderkunst/54.jpg", caption: ""},
    {href : "./Kinderkunst/55.jpg", caption: ""},
    {href : "./Kinderkunst/56.jpg", caption: ""},
    {href : "./Kinderkunst/57.JPG", caption: ""},
    {href : "./Kinderkunst/58.jpg", caption: ""},
    {href : "./Kinderkunst/59.jpg", caption: ""},
    {href : "./Kinderkunst/60.jpg", caption: ""},
    {href : "./Kinderkunst/61.jpg", caption: ""},
    {href : "./Kinderkunst/62.jpg", caption: ""},
    {href : "./Kinderkunst/63.jpg", caption: ""},
    {href : "./Kinderkunst/64.jpg", caption: ""},
    {href : "./Kinderkunst/65.jpg", caption: ""},
    {href : "./Kinderkunst/66.jpg", caption: ""},
    {href : "./Kinderkunst/67.jpg", caption: ""},
    {href : "./Kinderkunst/68.jpg", caption: ""},
    {href : "./Kinderkunst/69.jpg", caption: ""},
    {href : "./Kinderkunst/70.jpg", caption: ""},
    {href : "./Kinderkunst/71.jpg", caption: ""},
    {href : "./Kinderkunst/72.jpg", caption: ""},
    {href : "./Kinderkunst/73.jpg", caption: ""},
    {href : "./Kinderkunst/74.jpg", caption: ""},
];

function Kinderkunst() {
    const reversedImages = images.slice().reverse();
    return (
        <div class="uk-container">
            <div class="uk-child-width-1-5@m uk-grid" uk-lightbox="animation: slide">
                {
                    // eslint-disable-next-line array-callback-return
                    reversedImages.map((image) => (
                        <div class="uk-card uk-card-body" style={{display: "flex", alignItems: "center" }}>
                            <div class="uk-display-block">
                                <a class="uk-inline uk-margin-auto uk-cover-container" href={image.href} data-caption={image.caption}>
                                    <img class="uk-visible@m" src={image.href.replace("./Kinderkunst/", "./thumbnails/Kinderkunst/")} width="1500" height="1200" alt={image.href.replace("./Kinderkunst/", "")} loading="lazy" uk-cover/>
                                    <img class="uk-hidden@m" src={image.href.replace("./Kinderkunst/", "./thumbnails/Kinderkunst/")} width="500" height="500" alt={image.href.replace("./Kinderkunst/", "")} loading="lazy" uk-cover/>
                                </a>
                            </div>
                        </div>
                    ))
                }
            </div>
            <br></br><br></br>
        </div>
    );
}

export default Kinderkunst;